import { Route, Routes } from 'react-router'
import { SiteHeader } from '@/components/chrome/SiteHeader'
import { SiteFooter } from '@/components/chrome/SiteFooter'
import { ScrollToTop } from '@/components/primitives'
import Home from '@/pages/Home'
import Platform from '@/pages/Platform'
import Integrations from '@/pages/Integrations'
import Solutions from '@/pages/Solutions'
import Nex from '@/pages/Nex'
import Security from '@/pages/Security'
import Walkthrough from '@/pages/Walkthrough'
import Legal from '@/pages/Legal'
import NotFound from '@/pages/NotFound'

export default function App() {
  return (
    <div className="flex min-h-svh flex-col bg-base-950">
      <ScrollToTop />
      <SiteHeader />
      <main id="main" className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/nex" element={<Nex />} />
          <Route path="/security" element={<Security />} />
          <Route path="/walkthrough" element={<Walkthrough />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
          <Route path="/terms" element={<Legal kind="terms" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <SiteFooter />
    </div>
  )
}
